import React from 'react';
import { Folder, Users, Activity, ExternalLink } from 'lucide-react';
export function ProjectCardArtifact({
  data
}: {
  data: any | any[];
}) {
  const projects = Array.isArray(data) ? data : [data];
  if (projects.length === 0) {
    return <div className="p-4 text-slate-500 text-sm" data-id="element-301">
        No hay proyectos para mostrar.
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4" data-id="element-302">
      {projects.map((project, idx) => {
      const name = project.name || 'Proyecto';
      const key = project.key || 'KEY';
      const type = project.projectTypeKey || project.type || 'software';
      const category = project.projectCategory?.name || 'General';
      return <div key={project.id || idx} className="bg-slate-900 rounded-xl border border-slate-800 p-5 hover:border-indigo-500/50 transition-all group hover:shadow-lg hover:shadow-indigo-500/10" data-id="element-303">
            <div className="flex justify-between items-start mb-4" data-id="element-304">
              <div className="flex items-center gap-3" data-id="element-305">
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-indigo-500/20 to-purple-500/20 border border-indigo-500/30 flex items-center justify-center text-indigo-400 font-bold text-lg" data-id="element-306">
                  {key.substring(0, 2)}
                </div>
                <div data-id="element-307">
                  <h3 className="font-bold text-slate-100 group-hover:text-indigo-300 transition-colors flex items-center gap-1.5 line-clamp-1" title={name} data-id="element-308">
                    {name}
                  </h3>
                  <div className="flex items-center gap-2 mt-1" data-id="element-309">
                    <span className="text-[10px] font-bold text-indigo-400 bg-indigo-950/50 px-1.5 py-0.5 rounded border border-indigo-900/50" data-id="element-310">
                      {key}
                    </span>
                    <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold" data-id="element-311">
                      {type}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5 pt-4 border-t border-slate-800/50 flex items-center justify-between" data-id="element-312">
              <div className="flex items-center gap-3" data-id="element-313">
                <div className="flex items-center gap-1.5 text-xs text-slate-400" title="Categoría" data-id="element-314">
                  <Folder size={14} className="text-slate-500" data-id="element-315" />
                  <span className="truncate max-w-[80px]" data-id="element-316">{category}</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-slate-400" title="Actividad" data-id="element-317">
                  <Activity size={14} className="text-emerald-500" data-id="element-318" />
                  <span data-id="element-319">Activo</span>
                </div>
              </div>
              <a href="#" className="p-1.5 text-slate-500 hover:text-indigo-400 hover:bg-indigo-950/30 rounded-md transition-colors" data-id="element-320">
                <ExternalLink size={14} data-id="element-321" />
              </a>
            </div>
          </div>;
    })}
    </div>;
}